import { ChatBrowserMessage } from "@/domains/chat/constants/chat";
import { formatCharacterId } from "@/domains/chat/helpers/formatCharacterId.ts";

export default function getPlayerContent(message: ChatBrowserMessage) {
  let name: string | null = null;

  if (message.player.name) {
    name = message.player.name;
  }

  if (!message.player.me && !message.player.know) {
    name = null;
  }

  const characterId = formatCharacterId(message.message.player.characterId);

  // const ids = [message.message.player.characterId];

  // let distance: string | null = null;
  // if (message.player.distance) {
  //   distance = `${message.player.distance.toFixed(2)} м.`;
  // }

  return `${name || "Незнакомец"} [${characterId}]`;
}
